<template>
  <transition name="notice-fade">
    <div v-if="visible" class="maintainNotice">
      <div class="mnHead">
        <span class="mnTitle">
          <i class="el-icon-warning-outline"></i>
          维护提醒
        </span>
        <span class="mnClose" title="关闭" @click="close">×</span>
      </div>
      <div class="mnBody">
        <p>浙江旅游保险服务平台</p>
        <p>将于2026年11月5日23点-次日6点</p>
        <p>将进行系统维护升级，届时将暂停业务的受理。</p>
        <p>如需业务录入，请错开维护时段。</p>
      </div>
      <div class="mnFoot">本提示将在 {{ countdown }} 秒后自动关闭</div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "maintainNotice",
  data() {
    return {
      visible: true,
      countdown: 8,
      timer: null,
    };
  },
  mounted() {
    this.startCountdown();
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    startCountdown() {
      this.clearTimer();
      this.timer = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          this.close();
        }
      }, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    close() {
      this.clearTimer();
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.maintainNotice {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  height: fit-content;
  z-index: 3000;
  width: 400px;
  box-sizing: border-box;
  padding: 0 0 12px;
  background: #fff;
  border-radius: 7px;
  border-left: 5px solid #e6a23c;
  box-shadow: 0 5px 18px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}
.mnHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px 9px;
  border-bottom: 1px solid #f0f0f0;
}
.mnTitle {
  display: flex;
  align-items: center;
  font-size: 17px;
  font-weight: 600;
  color: #e6a23c;
}
.mnTitle i {
  margin-right: 6px;
  font-size: 18px;
}
.mnClose {
  width: 24px;
  height: 24px;
  line-height: 22px;
  text-align: center;
  font-size: 21px;
  color: #999;
  cursor: pointer;
  border-radius: 50%;
  user-select: none;
}
.mnClose:hover {
  color: #fff;
  background: #c0c4cc;
}
.mnBody {
  padding: 10px 14px 0;
  font-size: 15px;
  line-height: 1.8;
  color: #606266;
}
.mnBody p {
  margin: 0;
}
.mnFoot {
  padding: 8px 14px 0;
  font-size: 13px;
  color: #909399;
}
.notice-fade-enter-active,
.notice-fade-leave-active {
  transition: opacity 0.25s, transform 0.25s;
}
.notice-fade-enter,
.notice-fade-leave-to {
  opacity: 0;
  transform: scale(0.92);
}
</style>
